module.exports = __webpack_public_path__ + "static/media/terminos_y_condiciones.094ff174.pdf";